import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/progress/index.js
// module id = 323
// module chunks = 1